import React from 'react';
import {Button} from '@shopify/polaris';
import {useNavigate} from "react-router-dom";

const LocalMenu = () => {
    const navigate = useNavigate();
    return (
        <div className="header-menu-admin">
            <Button size="large" onClick={() => {
                navigate('/')
            }}>Pricing Rule List</Button>
            <Button size="large" onClick={() => {
                navigate('/create-rules')
            }}>Create Pricing Rule</Button>
            <Button size="large" onClick={() => {
                navigate('/order-analytics')
            }}>Order Analytics</Button>
            <Button size="large" onClick={() => {
                navigate('/settings')
            }}>Settings</Button>
            {/* <Button size="large" onClick={() => {
                navigate('/pricing')
            }}>Pricing</Button> */}
            <Button size="large" onClick={() => {
                navigate('/faq')
            }}>FAQ</Button>
        </div>
    );
};

export default LocalMenu;
